import { Stack } from "@mui/material";
import HelpButton from "../HelpButton";
import {
  SimpleTableDialogExplainSection,
  SimpleTableDialogReference,
  SimpleTableDialogTableSection,
} from "./commons/SimpleTableHelpDialog";

export default function SASRiskDialog() {
  return (
    <HelpButton dialogTitle="不眠症のリスク">
      <Stack gap={6}>
        <SimpleTableDialogExplainSection
          title="判定の仕組み"
          content="アテネ不眠尺度の結果から不眠症のリスクを判定しています。また、SLEEP COMPASSで判定した睡眠の長さ・質を元に受診をおすすめするかどうか記載しています。睡眠は主観と客観がズレやすいため、不安がある場合は受診すると良いでしょう。"
        />
        <SimpleTableDialogExplainSection
          title="アテネ不眠尺度とは"
          content="不眠の重症度を評価するための質問紙としてICD-10の診断基準に基づき作成された指標です。全8問で構成され、各問0~3点で合計得点を算出し、6点以上を不眠症のカットオフ点としています。"
        />
        <SimpleTableDialogTableSection
          title="アテネ不眠尺度の重症度"
          records={[
            ["アテネ不眠尺度の点数", "重症度"],
            ["0-5点", "正常"],
            ["6-9点", "軽症の不眠症が疑われます"],
            ["10-15点", "中等症の不眠症が疑われます"],
            ["16-24点", "重症の不眠症が疑われます"],
          ]}
        />
        <SimpleTableDialogReference>
          臨床睡眠検査マニュアル（日本睡眠学会）
        </SimpleTableDialogReference>
      </Stack>
    </HelpButton>
  );
}
